module.exports = {
	"account.user.driving.licence.already.exist": "Esiste già un altro account con questo numero di patente.",
	"account.user.login.already.exist": "Questo indirizzo email è già in uso da parte di un altro account.",
	"account.user.suspended": "Impossibile eseguire questa azione perché l'utente è sospeso",
	"action.add.payment": "Aggiungi metodo di pagamento",
	"action.complete.my.account": "Completa il mio account",
	"action.confirm.welcome.msg": "Andiamo",
	"action.create.my.account": "Crea il mio account",
	"action.search.update.bookings": "Verifica disponibilità",
	"action.update.payment": "Aggiorna metodo di pagamento",
	"anonymous.search.location.not.available": "The search is not available for this location",
	"booking.accept_usage_terms.link.label": "Terms of use",
	"booking.accept_usage_terms.text": "Cliccando su \"Conferma\", dichiari di accettare i termini e le condizioni del servizio e di essere in possesso di una patente di guida valida per l’utilizzo del servizio di car sharing. Maggiori informazioni nel {link}.",
	"booking.accept_usage_terms.title": "Condizioni generali di utilizzo",
	"booking.action.cancel.forbidden": "Non è più possibile annullare la prenotazione",
	"booking.action.edit.forbidden": "Non è più possibile modificare la prenotazione",
	"booking.add.calendar": "Aggiungi al calendario",
	"booking.confirm": "Conferma prenotazione",
	"booking.confirm_and_pay": "Confermare e pagare",
	"booking.deposit": "Deposito di sicurezza",
	"booking.deposit.b": "Al momento della conferma della prenotazione verrà addebitato un deposito bancario di {damageSafetyDeposit} {currency}\n Questo deposito può essere utilizzato per coprire eventuali danni causati al veicolo durante il viaggio. \n\n Se il veicolo verrà restituito senza danni o straordinari, verrà addebitato {bookingPrice} {currency}",
	"booking.deposit.d": "Al momento della conferma della prenotazione verrà effettuato un deposito bancario dell'importo di {bufferPrice} {currency}\n Ciò include il prezzo della prenotazione e un addebito per coprire eventuali superamenti. \n\n Senza un sovraccarico o un danno al veicolo, solo {bookingPrice} {currency} verrà addebitato sul tuo conto.",
	"booking.deposit.db": "Alla conferma della prenotazione verranno addebitati due depositi bancari:\n — Il primo dell'importo di {bufferPrice} {currency} , compreso il prezzo della prenotazione e un addebito per coprire eventuali sforamenti.\n — Il secondo per un importo di {damageSafetyDeposit} {currency} per coprire eventuali danni causati al veicolo durante la prenotazione. \n\n Senza alcun sovraccarico o danno al veicolo, verrà addebitato {bookingPrice} {currency}",
	"booking.deposit.info": "Verrà versato un acconto per la tua prenotazione",
	"booking.payment.prebilling.refused.error": "La transazione è stata rifiutata perché l'addebito sulla tua carta non è riuscito. Riprova con un'altra carta. Se il problema persiste, contatta la tua banca.",
	"booking.payment.prebilling.technical.error": "Si è verificato un errore durante il pagamento. Riprova più tardi.",
	"booking.success.sub.title": "Grazie per aver utilizzato il nostro servizio!",
	"booking.success.title": "Congratulazioni, la tua prenotazione è stata creata con successo!",
	"booking.type.label": "Tipo di prenotazione",
	"booking.type.one_way": "Sola andata",
	"booking.type.return_trip": "Andata e ritorno",
	"booking.update.period.expired": "Il periodo per l'aggiornamento delle date della prenotazione è scaduto",
	"booking.usage.business": "Aziendale",
	"booking.usage.private": "Privata",
	"booking.view_payment_terms.title": "Termini di pagamento",
	"booking.voucher.different.code": "Non puoi modificare il tuo codice promozionale",
	"booking.voucher.placeholder": "Ho un codice promozionale",
	"car.AUTOMATIC": "Automatico",
	"car.DIESEL": "Diesel",
	"car.ELECTRIC": "Elettrica",
	"car.FOLDING_SEATS": "Sedili reclinabili",
	"car.GPS": "GPS",
	"car.HYBRID": "Ibrida",
	"car.LPG": "GPL",
	"car.MANUAL": "Manuale",
	"car.PETROL": "Benzina",
	"car.RADIO_CD": "Radio",
	"car.booking_details": "Dettagli prenotazione",
	"car.color": "Colore",
	"car.compact_cars": "Compact",
	"car.description": "Description",
	"car.details": "Dettagli veicolo",
	"car.doors": "Porte",
	"car.filter.COMMERCIAL": "Commerciale",
	"car.filter.PASSENGER": "Turistica",
	"car.filter.accessories.air_conditioning": "Aria condizionata",
	"car.filter.accessories.baby_seat": "Baby seat",
	"car.filter.accessories.bluetooth": "Bluetooth",
	"car.filter.accessories.large_truck": "Grand coffre",
	"car.filter.accessories.radio_cd": "Radio",
	"car.filter.label_nb_persons": "Numero di persone",
	"car.filter.other": "Altro",
	"car.filter.other-nb": "Altri - {nb}",
	"car.filter.vehicle_type": "Tipo di veicolo",
	"car.filter_energy": "Energia",
	"car.filter_gearbox_type": "Tipo di cambio",
	"car.filter_persons": "persone",
	"car.for_every_additional_km": "Per chilometro aggiuntivo",
	"car.km_included": "Km inclusi",
	"car.motorization": "Motorizzazione",
	"car.options": "Opzioni",
	"car.parking_additional_info": "Dettagli specifici del parcheggio",
	"car.places": "Posti",
	"car.pricing": "Tariffe",
	"car.pricing.estimate": "Preventivo",
	"car.pricing.extra_km_cost_per_day": "Prezzo km extra",
	"car.pricing.free_km_per_day": "Km inclusi / 24 h",
	"car.specifications": "Specifiche",
	"car.transmission": "Cambio",
	"car.utility_cars": "Utilitaria",
	"car.version": "Versione",
	"company.id.missing.booking.search": "L'ID azienda è obbligatorio per la ricerca anonima della prenotazione",
	"contact_page.phone_call_price": "(CHIAMATA GRATUITA DA RETE FISSA)",
	"contact_page.title_1": "Per qualsiasi domanda relativa al noleggio auto,",
	"contact_page.title_2": "non esitare a contattarci via email.",
	"creditcard.data.insufficient.3ds": "A causa dei nuovi requisiti 3DS2, ti chiediamo di aggiornare i tuoi dati di pagamento.",
	"custom.field.type.boolean": "Si/No",
	"data.with.colon": "{data}:",
	"document.issue.date": "Data di rilascio",
	"dropzone.inner.info": "File consentiti: JPEG, PNG, PDF",
	"dropzone.inner.title": "Carica il tuo documento",
	"error.booking.member_invalid": "Il profilo non è ancora stato verificato.",
	"error.booking.no.usage": "Nessun utilizzo per queste date di prenotazione",
	"error.booking.no_credit_card": "Aggiungi prima i dati della tua carta di credito.",
	"error.booking.same_period": "Ha già una prenotazione per questo periodo.",
	"error.change_password.400.bad_request": "La password è errata",
	"error.contract.inactive": "Il servizio non è attivo per la tua azienda. Contatta il responsabile del servizio.",
	"error.contract.not-found": "Il servizio è stato sospeso dalla tua azienda. Contatta il responsabile del servizio.",
	"error.credit.card.refused": "Carta di credito rifiutata",
	"error.forgot_password.404": "Account non trovato, controlla il tuo indirizzo email",
	"error.form.email.already_exists": "Inserisci un altro indirizzo email",
	"error.form.email_invalid": "Inserisci un'email valida",
	"error.form.inviteCode.notEmpty": "Inserisci un codice di invito",
	"error.form.password.at_least": "La password deve contenere almeno 8 caratteri",
	"error.form.password.at_most": "La password può contenere fino a 25 caratteri",
	"error.form.password.cannot_reset_same": "La nuova password deve essere diversa da quella attuale",
	"error.form.password.digit": "La password deve contenere 1 numero",
	"error.form.password.lower_letter": "La password deve contenere 1 lettera minuscola",
	"error.form.password.upper_letter": "La password deve contenere 1 lettera maiuscola",
	"error.form.password_confirmation.the_same": "Inserisci la stessa password due volte",
	"error.form.password_old.the_same": "La nuova password deve essere diversa da quelle usate in precedenza",
	"error.form.required": "Compila tutti i campi obbligatori",
	"error.form.suggestion.address.required": "Seleziona l'indirizzo dall'elenco dei suggerimenti",
	"error.form.technical": "Errore tecnico",
	"error.get.site.config": "Impossibile caricare la configurazione del sito",
	"error.invite.code.invalid": "La community a cui vuoi unirti non esiste",
	"error.login.401.unauthorized": "Email o password errate",
	"error.login.403.user.anonymized": "Il tuo account è stato reso anonimo e non puoi più utilizzarlo",
	"error.login.422.user.not.enabled": "Il tuo account non è ancora stato attivato. Controlla la posta in arrivo e segui le istruzioni per attivarlo.",
	"error.number.above.max": "Il valore non può essere superiore a {value}",
	"error.number.below.min": "Il valore non può essere inferiore a {value}",
	"error.phone.format.invalid": "Il formato del numero di telefono è errato",
	"error.register.without.sso": "You can only subscribe using SSO",
	"error.request_error": "Errore di richiesta",
	"error.reset_password.401": "Il link fornito non è più valido. Richiedi un'altra password sul sito",
	"error.search.vehicles.403": "Non puoi accedere al sito selezionato con il profilo attivo corrente",
	"error.session.expired": "Sessione scaduta",
	"error.text.length.long": "Questo campo ha un limite di {count} caratteri",
	"error.text.length.short": "Questo campo deve avere almeno {count} caratteri",
	"error.user.verify.fail": "User verification failed",
	"error_profile_edit_member_approved": "Il nome e la data di nascita non possono essere modificati una volta verificato il profilo",
	"faq.contactEmailFallback": "alla nostra email di contatto",
	"faq.contactPhoneFallback": "in fondo alla pagina",
	"faq.other_question": "Non trovi la risposta alla tua domanda?",
	"file_upload_size_exceeded": "Il file è troppo grande. Dimensione massima: 5 MB",
	"footer.label.legal.information": "Informazione legale",
	"footer.label.personal.data": "Dati personali",
	"footer_callUs": "Chiamaci",
	"footer_other": "Altro",
	"footer_share": "Seguici",
	"footer_society_about": "Chi siamo",
	"footer_society_policy_privacy": "Informativa Privacy",
	"footer_society_term": "Condizioni di Contratto",
	"footer_writeUs": "Scrivici un'email",
	"forgot_password.confirmation": "Abbiamo inviato un link per reimpostare la password al tuo indirizzo email.",
	"forgot_password.description_line1": "Inserisci l'indirizzo email associato al tuo account.",
	"forgot_password.description_line2": "Ti invieremo un link per reimpostare la password.",
	"forgot_password.submit": "Inviami il link di ripristino",
	"generic.address": "Indirizzo",
	"generic.at": "a",
	"generic.book": "Prenotare",
	"generic.cancel": "Annulla",
	"generic.canceled": "Annullato",
	"generic.city": "Città",
	"generic.clear": "Effacer",
	"generic.company": "Azienda",
	"generic.completed": "Completato",
	"generic.country": "Paese",
	"generic.email": "Email",
	"generic.end": "Fine",
	"generic.expires.at": "Scade",
	"generic.extend": "Estendere",
	"generic.file": "File",
	"generic.first.name": "Nome",
	"generic.last.name": "Cognome",
	"generic.location.fixture.label": "Siti",
	"generic.location.history.label": "Storia",
	"generic.location.search.placeholder": "Cerca un indirizzo, una città...",
	"generic.mobile.phone": "Numero di cellulare",
	"generic.modify": "Modifica",
	"generic.mr": "Sig.",
	"generic.mrs": "Sig.ra.",
	"generic.next": "Avanti",
	"generic.number": "Numero",
	"generic.passport": "Passaporto",
	"generic.past.placeholder": "Trova qui le tue prenotazioni passate",
	"generic.phone.number": "Numero di telefono",
	"generic.postal.code": "Codice postale",
	"generic.retry": "Riprova",
	"generic.save": "Salva",
	"generic.send": "Inviare",
	"generic.start": "Inizio",
	"generic.text": "Testo",
	"generic.today": "Oggi",
	"generic.upcoming": "Prossimo",
	"generic.updated": "Aggiornato",
	"generic.user": "Utente",
	"get.sso.config.fail": "This email address is not recognized for SSO login",
	"helpPage_carSharing_issue1_answer": "Per registrarti, basta andare al sito Intranet della tua azienda, troverai un link che ti porterà all'interfaccia di registrazione. (Oppure invia una richiesta di inserimento a {contactEmail}). Riceverai un link via e-mail.",
	"helpPage_carSharing_issue1_title": "Come registrarsi?",
	"helpPage_carSharing_issue2_answer": "È possibile reimpostare la password dal sito Web o applicazioni mobili: riceverai in questo caso al tuo indirizzo e-mail registrato, un link per impostare la nuova password.",
	"helpPage_carSharing_issue2_title": "Cosa devo fare se perdo la password?",
	"helpPage_carSharing_issue3_answer": "Nel caso tu smarrisca il tuo badge o ne abbia uno nuovo, sei pregato di contattare il Call Center al {contactPhone} per reimpostarlo. Un nuovo badge non funziona se non viene prima reimpostato.",
	"helpPage_carSharing_issue3_title": "Cosa devo fare se perdo il mio badge o ne ho uno nuovo?",
	"helpPage_carSharing_issue4_answer": "La targa del tuo veicolo è indicata nell'e-mail e nell'SMS di conferma. Oppure potrai trovare il veicolo sul sito nella scheda Le Mie Prenotazioni.",
	"helpPage_carSharing_issue4_title": "Quale veicolo ho prenotato?",
	"helpPage_carSharing_issue5_answer": "Accertati che la data e l'ora siano corrette, il pulsante di avvio è disponibile soltanto dal momento in cui parte la prenotazione. Altrimenti, è possibile strisciare il badge sul lettore per aprire le portiere del veicolo.",
	"helpPage_carSharing_issue5_title": "Perché non riesco a trovare il pulsante di avvio?",
	"helpPage_carSharing_issue6_answer": "Se hai effettuato una prenotazione e la luce diventa verde, ma la portiera non si apre, premi il pulsante situato sulla sua maniglia.",
	"helpPage_carSharing_issue6_title": "Perché la spia è verde, ma le porte sono ancora chiuse?",
	"helpPage_carSharing_issue7_answer": "Una volta che hai prenotato il veicolo, è anche possibile modificare o cancellare la prenotazione, dal sito Web o tramite l'applicazione mobile. Nel caso tu abbia bisogno di assistenza, ti preghiamo di contattare il Call Center al {contactPhone}.",
	"helpPage_carSharing_issue7_title": "Modifica / Annullamento",
	"helpPage_carSharing_issue8_answer": "Non si può strisciare il badge in anticipo, è possibile aprire il veicolo solo a partire dall'orario esatto.",
	"helpPage_carSharing_issue8_title": "Posso strisciare il badge in anticipo?",
	"helpPage_damages_issue1_answer": "Prima che abbia inizio la tua prenotazione, per favore accertati di segnalare i danni tramite l'app del tuo cellulare oppure chiamando il Call Center al {contactPhone}.",
	"helpPage_damages_issue1_title": "Cosa fare nel caso in cui il veicolo prenotato sia danneggiato?",
	"helpPage_damages_issue2_answer": "Mantieni la calma e assicurati che nessuno sia ferito. Sei sotto copertura assicurativa. Per favore, contatta al più presto il Call Center al {contactPhone} per avere ulteriori istruzioni.",
	"helpPage_damages_issue2_title": "Cosa fare in caso di incidente durante l'arco della mia prenotazione?",
	"helpPage_subtitle": "In questa sezione troverai le risposte alle domande poste più di frequente.",
	"helpPage_tab_carSharing": "Servizio",
	"helpPage_tab_damages": "Danni",
	"helpPage_tab_vehicles": "Veicolo",
	"helpPage_title": "Domande frequenti (FAQ)",
	"helpPage_vehicles_issue1_answer": "Verifica date e orari della tua prenotazione, quindi controlla se la targa corrisponde alla tua prenotazione. Poi striscia di nuovo presentando al lettore SOLO il tuo badge. Assicurati che il badge utilizzato appartenga alla stessa persona che ha effettuato la prenotazione e che non sia stato modificato dall'ultima prenotazione. In caso di un recente cambio del badge, sei pregato di contattare il Servizio Clienti per apportare una modifica immediata.",
	"helpPage_vehicles_issue1_title": "Perché il veicolo non risponde?",
	"helpPage_vehicles_issue2_answer": "Verifica date e orari della tua prenotazione, quindi controlla se la targa corrisponde alla tua prenotazione. Assicurati di essere in possesso del badge corretto (quello della persona che ha effettuato la prenotazione).",
	"helpPage_vehicles_issue2_title": "Perché il lettore della carta mostra solo una spia rossa?",
	"helpPage_vehicles_issue3_answer": "Se hai una prenotazione, e la spia è verde ma non senti che le portiere si sbloccano, premi il pulsante sulla portiera del conducente per sbloccarle tutte.",
	"helpPage_vehicles_issue3_title": "Perché le portiere rimangono chiuse?",
	"helpPage_vehicles_issue4_answer": "Controlla che la targa del veicolo, le date e gli orari siano corretti, e assicurati di avere una sufficiente connessione a Internet.",
	"helpPage_vehicles_issue4_title": "Perché non riesco ad aprire le portiere?",
	"helpPage_vehicles_issue5_answer": "Basta assicurarsi che il motore sia spento, le portiere e il bagagliaio siano correttamente chiusi, le chiavi con il microchip siano state ricollocate nella cassetta situata nel vano portaoggetti.",
	"helpPage_vehicles_issue5_title": "Perché non riesco a bloccare il veicolo?",
	"home.header_banner": "A ottobre, <strong> Renault Mobility </strong> diventerà <strong> Mobilize share </strong>",
	"home.welcome": "Benvenuto a {productName}",
	"home.welcome_solo": "Benvenuto",
	"how_it_works.step_1": "<span class='bold'>Scarica l'applicazione</span> da App Store o Google Play.",
	"how_it_works.step_2": "Avvia l'applicazione e <span class='bold'>registrati</span> compilando il modulo.",
	"how_it_works.step_3": "Scatta una foto della tua <span class='bold'>patente di guida</span> e <span class='bold'>carta d'identità</span> e <span class='bold'>scatta una foto del tuo viso</span> con accanto la carta d'identità, quindi salva tutto nell'app!",
	"how_it_works.step_4": "<span class='bold'>Registra la tua carta di credito</span> per gestire il pagamento dei noleggi.",
	"how_it_works.step_5": "<span class='bold'>Verifica il tuo indirizzo email</span> cliccando su link che ti abbiamo inviato. <span class='bold'>Controlla anche nella cartella SPAM</span>.",
	"how_it_works.step_6": "Una volta verificata la registrazione, <span class='bold'>prenota pure il tuo veicolo</span> sulla nostra app o sul nostro sito. Il giorno della prenotazione, <span class='bold'> potrai usare il telefono come chiave!</span>",
	"info.account.company.already.linked": "Questa azienda è già collegata al tuo account",
	"info.switch.profile": "<strong>New — </strong>You can now add and manage multiple profiles using the same credentials. This allows you to join corporate fleets of you company and use the same app to rent a vehicle for your week-ends.",
	"info.switching.profile": "Cambio profilo",
	"info.worldpay.return.success": "Informazioni di pagamento allegate",
	"iso__BE": "Belgio",
	"iso__CS": "Repubblica Ceca",
	"iso__DA": "Danimarca",
	"iso__DE": "Germania",
	"iso__ES": "Spagna",
	"iso__FR": "Francia",
	"iso__IT": "Italia",
	"iso__NL": "Paesi Bassi",
	"iso__PL": "Polonia",
	"iso__PT": "Portogallo",
	"iso__SL": "Slovenia",
	"iso__SV": "Svezia",
	"iso__pt_BR": "Brasile",
	"label.accept_terms_and_conditions": "Autorizzo Renault e la sua rete a ricontattarmi via email ai fini di indagini o informazioni su nuovi prodotti e offerte in corso. Ad ogni invio avrò la possibilità di porre fine alle comunicazioni.",
	"label.account.already.active": "Il tuo account è già attivo",
	"label.account_activation_description": "Quando l'account sarà stato verificato riceverai un'email di conferma e potrai iniziare a usufruire del servizio completo.",
	"label.account_activation_title": "Grazie per aver effettuato la registrazione. La tua richiesta è in fase di elaborazione. Il tuo account verrà validato non appena esamineremo il tuo profilo.",
	"label.activation.link.expired": "Il link di attivazione è scaduto",
	"label.activation.link.send": "Invia di nuovo",
	"label.activation.link.sent.success": "L'email di attivazione verrà inviata se l'utente esiste e l'account non è attivato",
	"label.active.profile": "Profilo attivo",
	"label.actual.payment.method": "Metodo di pagamento attuale",
	"label.add.new.profile": "Aggiungi nuovo profilo",
	"label.apply": "Applica",
	"label.are_you_sure_you_want_to_cancel": "Desideri confermare la cancellazione?",
	"label.birth.day": "Data di nascita",
	"label.booking": "Prenotazione",
	"label.booking.past": "Passato",
	"label.booking.past.placeholder": "Qui trovi la cronologia delle prenotazioni.",
	"label.booking.today.part": "oggi alle",
	"label.booking.upcoming.placeholder": "Qui trovi le tue prenotazioni in programma e in corso",
	"label.cancel_my_booking": "Cancella la prenotazione",
	"label.car": "veicolo",
	"label.carSharing": "Condividere l'auto",
	"label.cars": "veicoli",
	"label.civility": "Appellativo",
	"label.click_here": "Clicca qui",
	"label.close": "Chiudi",
	"label.confirm_new_password": "Conferma password",
	"label.congratulations": "Congratulazioni!",
	"label.continue": "Continua",
	"label.creditCard_message": "Per convalidare la carta, effettueremo un addebito temporaneo. Potresti vedere un addebito di un piccolo importo ({amountToTake}€) sul conto associato alla tua carta. Se l'addebito non viene annullato dopo cinque giorni lavorativi, contatta la tua banca.",
	"label.date": "Data",
	"label.delivery_place": "Rilasciata da",
	"label.driving_licence": "Patente di guida",
	"label.driving_licence_back": "Patente di guida (retro)",
	"label.driving_licence_front": "Patente di guida (fronte)",
	"label.edit.invite.code": "Modifica il codice di invito",
	"label.expiration_date": "Data di scadenza",
	"label.file.upload.only.mobile": "Per modificare i documenti, utilizza l'app mobile.",
	"label.filter_by": "Filtra per",
	"label.filters": "Filtri",
	"label.generic.error": "Si è verificato un errore. Riprova più tardi.",
	"label.hours": "ore",
	"label.how_it_works": "Come funziona?",
	"label.identity.card": "Carta d'identità",
	"label.identity.document.number": "Numero documento d'identità",
	"label.identity.document.type": "Tipo di documento d'identità",
	"label.identity_card": "Carta d'identità",
	"label.identity_card_back": "Carta d'identità (retro)",
	"label.identity_card_front": "Carta d'identità (fronte)",
	"label.identity_card_selfie": "Selfie con il tuo documento d'identità",
	"label.invite_code_placeholder": "Inserisci il tuo codice invito",
	"label.italy.fiscal.code": "Inserire il tuo codice ficale italiano (in MAIUSCOLO)",
	"label.italy.resident": "Risiedi in Italia e possiedi un codice fiscale italiano?",
	"label.licence_number": "Numero di patente",
	"label.load_more": "Altri risultati",
	"label.login": "Accedi",
	"label.logout": "Esci",
	"label.manager.email": "Email del tuo manager",
	"label.mandatory_fields": "* Campi obbligatori",
	"label.member_already": "Hai già un account",
	"label.my_account": "Il mio account",
	"label.my_reservations": "Le mie prenotazioni",
	"label.new.password": "Nuova password",
	"label.no_account": "Non hai un account?",
	"label.or_by_phone": "O per telefono",
	"label.password": "Password",
	"label.password_forgot": "Password dimenticata",
	"label.phone": "Telefono",
	"label.phone.suffix": "Suffisso telefonico",
	"label.plateNumber": "Targa",
	"label.price": "prezzo",
	"label.redirectMobileApp": "Per iniziare la prenotazione, scarica la nostra app mobile!",
	"label.remember_me": "Mantieni l'accesso",
	"label.reset_password_done": "La password è stata aggiornata",
	"label.return": "Indietro",
	"label.schedule": "Ore",
	"label.search": "Ricerca",
	"label.selected.language": "Lingua selezionata",
	"label.subject": "Oggetto",
	"label.switch.profile": "Cambia profilo",
	"label.the": "a",
	"label.validate": "Verifica",
	"label.vehicles_found": "{count} risultati trovati",
	"label.warning": "Attenzione",
	"label.welcome.finish.registration": "Per confermare l'appuntamento, completa la registrazione.",
	"label.you_are_trying_to_cancel_your_booking": "Stai per cancellare la prenotazione!",
	"label.your.active.profile": "Il tuo profilo attivo",
	"label.your.other.profiles": "I tuoi altri profili",
	"label.your_message": "Il tuo messaggio",
	"language.header": "Seleziona la tua lingua",
	"login.forgot_password": "Password dimenticata?",
	"login.register": "Registrati",
	"menu.faq": "Info",
	"mobile_banner.text": "Scarica l'applicazione {productName}",
	"page.password.update.sub.title": "Per motivi di sicurezza ti chiediamo di aggiornare la tua password",
	"page.password.update.title": "Aggiornamento password",
	"parking.special_opening_legend": "Orari di apertura speciali",
	"part.company.fill.extra.info": "richiede alcune informazioni aggiuntive.",
	"part.complete.register.for": "Completa la tua registrazione con",
	"part.create.account.for": "Crea un account per",
	"part.link.account.to": "Collega il tuo account a",
	"part.your.email": "la tua email",
	"placeholder.enter.number": "Immettere un numero ...",
	"placeholder.enter.text": "Digitare qui ...",
	"placeholder.search": "Ricerca ...",
	"profile.422.error.info": "Sembra che nel tuo profilo manchino alcune informazioni.\n Verifichiamo insieme il tuo profilo per assicurarci che sia tutto a posto.",
	"profile.info.new.email": "Se aggiorni il tuo indirizzo email, riceverai un'email per verificarlo. Senza la verifica non potrai più fare prenotazioni.",
	"profile.label.before.arrival": "Prima dell'arrivo",
	"profile.label.before.departure": "Prima della partenza",
	"profile.label.charges.call.center": "Per modifiche apportate a mio nome",
	"profile.label.charges.my": "Per modifiche apportate da me",
	"profile.label.current.password": "Password attuale",
	"profile.label.expiration.date.status": "La mia patente di guida non ha una data di scadenza",
	"profile.label.min.15": "15 minuti",
	"profile.label.min.30": "30 minuti",
	"profile.label.min.45": "45 minuti",
	"profile.label.new.email": "Nuovo indirizzo email",
	"profile.label.street.field": "Indirizzo (via e numero civico)",
	"profile.label.validated.email": "Hai verificato il tuo indirizzo email",
	"profile.section.additional.info": "Informazioni aggiuntive",
	"profile.section.credentials": "Credenziali",
	"profile.section.language": "Lingua del profilo",
	"profile.section.notifications": "Notifiche e avvisi",
	"profile.section.payment.info": "Informazioni di pagamento",
	"profile.section.personal.info": "Dati personali",
	"profile.section.selfie": "Autoscatto",
	"profile.section.technician.access": "Accesso tecnico",
	"profile.select.menu.item": "Seleziona una voce dal menu a sinistra",
	"profile.selfie.section.info": "Scatta un selfie mostrando la carta d'identità accanto al viso.",
	"profile.suspended": "Il tuo profilo è sospeso",
	"profile.title.email.notifications": "Notifiche via e-mail",
	"profile.title.language.select": "Lingua utilizzata per le notifiche e le e-mail",
	"profile.title.sms.notifications": "Notifiche SMS",
	"profile.title.update.email": "Aggiorna il tuo indirizzo email",
	"profile.title.update.password": "Aggiorna la password",
	"profile_error_driver_license_invalid": "La patente non è valida",
	"register.field.info.password": "Deve contenere almeno 1 numero, 1 lettera maiuscola, 1 lettera minuscola e tra 8 e 25 caratteri",
	"register.info.payment.saved": "Metodo di pagamento salvato.",
	"register.info.profile.creation.forbidden": "You can't link your profile to this company",
	"register.success.info": "Abbiamo inviato un link di attivazione a {email}. Controlla la posta in arrivo e la cartella spam, quindi segui le istruzioni per attivare il tuo account prima dello scadere del link.",
	"register.terms.ads": "Do il consenso al trattamento dei miei dati per finalità marketing (con modalità sia automatizzate che tradizionali) in relazione a prodotti e/o servizi di mobilità",
	"register.terms.prefix.accept": "Accetto",
	"register.terms.privacy.link.label": "Privacy policy",
	"register.terms.privacy.text": "I accept the {link} of {company}",
	"register.terms.root.privacy": "Informativa Privacy",
	"register.terms.root.tos": "Termini di sottoscrizione",
	"register.terms.root.tou": "Condizioni di Contratto",
	"register.terms.suffix.ads": "utilizzo dei miei dati per fini commerciali",
	"register.terms.suffix.of": "di",
	"register.terms.usage.link.label": "Terms of use",
	"register.terms.usage.subscription.link.label": "Terms of subscription",
	"register.terms.usage.subscription.text": "I accept the {link} of {company}",
	"register.terms.usage.text": "I accept the {link} of {company}",
	"register.title.account.created": "Congratulazioni {firstName}, il tuo conto è stato creato",
	"register.title.account.linked": "Congratulazioni {firstName}, il nuovo profilo è stato collegato al tuo account",
	"register.title.account.updated": "Congratulazioni {firstName}, il tuo account è stato aggiornato",
	"reset_password.title": "Reimposta password",
	"search.filter_alphabetically": "Ordine alfabetico",
	"search.filter_by": "Ordina per",
	"search.filter_by_price": "Prezzo",
	"search.result.empty": "Nessun risultato",
	"service.corporate.intro": "Vuoi entrare a far parte di una community? Inserisci un codice invito.",
	"service.intro_label": "A quale servizio {productName} desideri iscriverti?",
	"service.private.intro": "Vuoi prenotare un veicolo della Rete {productName}?",
	"service.private.renaultfr": "Per iscriverti a {productName}, scarica l'app sul tuo store mobile.",
	"service.private.select_country": "Seleziona un paese",
	"service.usage.corporate": "Car sharing aziendale",
	"service.usage.private": "Carsharing 24 ore su 24",
	"service.usage.vr": "Veicolo sostitutivo",
	"service.vr.intro": "Grazie per aver scelto il nostro servizio!\n\nPer accedere al servizio, contatta il tuo concessionario.",
	"sncf.home.login.msg": "Are you an SNCF employee? Log in.",
	"sso.login.description": "Inserisci il tuo indirizzo email di lavoro",
	"sso.login.title": "Connettiti con SSO",
	"status.APPROVED": "Profilo convalidato",
	"status.NOT_APPROVED": "Il tuo profilo è stato rifiutato. Aggiorna il tuo profilo.",
	"status.TO_COMPLETE": "Incompleto",
	"status.TO_REVIEW": "Il tuo profilo è in attesa di convalida",
	"tagline": "Noleggio auto self service 24 ore su 24",
	"title.add.payment.later": "Puoi aggiungerlo in seguito.",
	"title.add.payment.method": "Aggiungi un metodo di pagamento.",
	"title.bookings.welcome.tutorial": "Trova qui la tua prenotazione, è già programmata",
	"title.modify.booking": "Modifica la mia prenotazione",
	"title.password.change.success": "La tua nuova password è stata salvata",
	"title.update.booking": "Aggiorna prenotazione",
	"title.welcome.to.brand": "Salve {firstName}, benvenuto su {brandName}.",
	"title.welcome.to.program": "Salve {firstName}, benvenuto nel programma {brandName} {program}.",
	"vehicle.incorrect.usage": "Il veicolo non è disponibile per questo tipo di uso",
	"week.day.friday": "Venerdì",
	"week.day.monday": "Lunedì",
	"week.day.saturday": "Sabato",
	"week.day.sunday": "Domenica",
	"week.day.thursday": "Giovedì",
	"week.day.tuesday": "Martedì",
	"week.day.wednesday": "Mercoledì"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n/it.json
 ** module id = 424
 ** module chunks = 0
 **/